import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import logo from '../images/logo.svg'

import Navigation from './Navigation'

class Menu extends Component {
	render() {
		return (
			<div id='menu'>
				<Link to='/'>
					<img src={logo} className='App-logo' alt='logo' />
				</Link>
				<Navigation />
			</div>
		)
	}
}

export default Menu
